// extracted by mini-css-extract-plugin
export default {"container":"DesktopModal--container--ZWZ9K"};